/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RansomwareRecoveryDeploymentStatesEnum = 'REQUESTED' | 'IN_PROGRESS' | 'ACTIVE' | 'INACTIVE' | 'FAILED' | 'DEACTIVATION_PENDING_APPROVAL' | 'DELETING';

export const RansomwareRecoveryDeploymentStatesEnum = {

    REQUESTED: 'REQUESTED' as RansomwareRecoveryDeploymentStatesEnum,

    IN_PROGRESS: 'IN_PROGRESS' as RansomwareRecoveryDeploymentStatesEnum,

    ACTIVE: 'ACTIVE' as RansomwareRecoveryDeploymentStatesEnum,

    INACTIVE: 'INACTIVE' as RansomwareRecoveryDeploymentStatesEnum,

    FAILED: 'FAILED' as RansomwareRecoveryDeploymentStatesEnum,

    DEACTIVATION_PENDING_APPROVAL: 'DEACTIVATION_PENDING_APPROVAL' as RansomwareRecoveryDeploymentStatesEnum,

    DELETING: 'DELETING' as RansomwareRecoveryDeploymentStatesEnum
};

